import { render, staticRenderFns } from "./detailCandidate.vue?vue&type=template&id=9cba45fa&"
import script from "./detailCandidate.vue?vue&type=script&lang=js&"
export * from "./detailCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports